// Centralized file-type definitions for uploads, in react-dropzone v14's
// `accept` format (MIME type -> list of file extensions). Use these instead of
// passing ad-hoc extension strings so the accepted types stay consistent and
// type-checked across every upload surface.

export const IMAGE_FILE_TYPES = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
};

export const IMAGE_AND_PDF_FILE_TYPES = {
  ...IMAGE_FILE_TYPES,
  'application/pdf': ['.pdf'],
};

// Human-readable list of extensions (e.g. ".jpg, .jpeg, .png, .pdf") for display
// to the user, derived from an `accept` map so there is one source of truth.
export const formatAcceptedExtensions = accept =>
  Object.values(accept).flat().join(', ');
